import { IonFabButton } from "@ionic/react";
import styled from "styled-components";

export const StyledFabButton: typeof IonFabButton = styled(IonFabButton)`
  --background: var(--allie-color-primary-60);
`;